import { put, takeLatest } from "redux-saga/effects";
import { danhSachNoTotNghiepApi } from "../../../api/xet-tot-nghiep/danhSachNoTotNghiepApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eDanhSachNoTotNghiepActionIds, IDanhSachNoTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IDanhSachNoTotNghiepActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
const mainActions = rootActions.xetTotNghiep.danhSachNoTotNghiep;


export function* danhSachNoTotNghiepSaga(): any {
    yield takeLatest(eDanhSachNoTotNghiepActionIds.LOAD_BY_DOT_XET_START, loadWorker);
}

function* loadWorker(action: IDanhSachNoTotNghiepActionTypes) : any {
    const id_xet_tot_nghiep = action.payload as number;
    const response: IBaseResponse = yield danhSachNoTotNghiepApi.SelectByDotXet(id_xet_tot_nghiep);
    if (response.is_success) {
        yield put(mainActions.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.LOAD_BY_DOT_XET_ERROR(response.message ?? "Không thể tải danh sách nợ tốt nghiệp"));
    }
}